// Labels and tones for the voice session state, shared by the dock's status
// chip and its error line. Kept out of the components so the mapping can be
// tested on its own and so both faces of the dock read from one table.

// Long form — used for the error line and any full-sentence surface.
export const STATE_TITLES = {
  connecting: "Connecting...",
  listening: "Listening",
  thinking: "Thinking",
  speaking: "Speaking",
  error: "Voice mode unavailable",
};

// Short form — the uppercase chip inside the bar, where width is scarce.
export const STATE_CHIP_LABELS = {
  idle: "Assistant",
  connecting: "Connecting",
  listening: "Listening",
  thinking: "Thinking",
  speaking: "Speaking",
  error: "Unavailable",
};

// Chip dot colours. `thinking` is orange to match the orb's hue-rotate — the
// two must move together or the bar contradicts the blob it sits next to.
export const STATE_TONES = {
  idle: "#9aa5b4",
  connecting: "#9aa5b4",
  listening: "#39a8f0",
  thinking: "#f59f0b",
  speaking: "#7fd1a3",
  error: "#ff8787",
};

export const getStateChipLabel = (voiceState) =>
  STATE_CHIP_LABELS[voiceState] || STATE_CHIP_LABELS.idle;

export const getStateTone = (voiceState) =>
  STATE_TONES[voiceState] || STATE_TONES.idle;
